import {
  FETCHING_CLEVERSTORY_WORKSPACES,
  FETCHING_CLEVERSTORY_WORKSPACES_SUCCEEDED,
  FETCHING_CLEVERSTORY_WORKSPACES_FAILED,
  CREATING_CLEVERSTORY_WORKSPACE_REQUEST,
  CREATING_CLEVERSTORY_WORKSPACE_SUCCEEDED,
  CREATING_CLEVERSTORY_WORKSPACE_FAILED,
  UPDATING_CLEVERSTORY_WORKSPACE_REQUEST,
  UPDATING_CLEVERSTORY_WORKSPACE_SUCCEEDED,
  UPDATING_CLEVERSTORY_WORKSPACE_FAILED
} from "constants/actionTypes";

const initState = {
  items: [],
  loading: false,

  createWorkspace: {
    creating: false,
    success: false,
    error: null,
  },
  updateWorkspace: {
    updating: false,
    success: false,
    error: null,
  },
  fetchingWorkspaces: {
    loading: false,
    success: false,
    error: null,
  },
};

function cleverstoryWorkspaceReducer(state = initState, action) {
  switch (action.type) {
    case CREATING_CLEVERSTORY_WORKSPACE_REQUEST: {
      return  {
        ...state,
        createWorkspace: { creating: true, error: null },
      };
    }

    case CREATING_CLEVERSTORY_WORKSPACE_SUCCEEDED: {
      var records = state.items.records;
      records = [...records, action.payload]
      return {
        ...state,
        items: {
          ...state.items,
          records: records
        },
        createWorkspace: { creating: false, success: true, error: null },
      };
    }

    case CREATING_CLEVERSTORY_WORKSPACE_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;
      return  {
        ...state,
        createWorkspace: { creating: false, error: error },
      };
    }

    case FETCHING_CLEVERSTORY_WORKSPACES: {
      return {
        ...state,
        fetchingWorkspaces: { loading: true, error: null },
        items:[],
        loading: true,
      };
    }

    case FETCHING_CLEVERSTORY_WORKSPACES_SUCCEEDED: {
      return  {
        ...state,
        fetchingWorkspaces: { loading: false, success: true, error: null },
        items: action.payload,
        loading: false,
      };
    }

    case FETCHING_CLEVERSTORY_WORKSPACES_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;

      return {
        ...state,
        fetchingWorkspaces: { fetching: false, success: false, error: error },
        loading: false,
        error: error
      };
    }
    case UPDATING_CLEVERSTORY_WORKSPACE_REQUEST: {
      return {
        ...state,
        updateWorkspace: { updating: true, error: null },
      };
    }

    case UPDATING_CLEVERSTORY_WORKSPACE_SUCCEEDED: {
      var records = state.items.records;
      var index = records.findIndex((item) => {
        return item.id === action.payload.id;
      })
      records[index] = action.payload;
      return{
        ...state,
        items: {
          ...state.items,
          records: records
        },
        updateWorkspace: { updating: false, success: true, error: null },

      };
    }

    case UPDATING_CLEVERSTORY_WORKSPACE_FAILED: {
      let error =
        action.payload && action.payload.errors
          ? action.payload.errors[0].message
          : null;
      return {
        ...state,
        updateWorkspace: { updating: false, error: error },
      };
    }

    default:
      return state;
  }
}

export { cleverstoryWorkspaceReducer };
